import type { ComponentProps, ReactNode } from "react"
import { HugeiconsIcon } from "@hugeicons/react"
import {
  AlertCircleIcon,
  CheckmarkCircle01Icon,
  InformationCircleIcon,
} from "@hugeicons/core-free-icons"
import { AlertAction, AlertDescription, AlertTitle, BaseAlert } from "../ui"

export type Props = ComponentProps<typeof BaseAlert> & {
  action?: ReactNode
}

const ICONS_MAP = {
  info: InformationCircleIcon,
  success: CheckmarkCircle01Icon,
  warning: AlertCircleIcon,
  error: AlertCircleIcon,
} as const

export default function Alert({
  action,
  variant,
  title,
  children,
  ...props
}: Props) {
  return (
    <BaseAlert variant={variant} {...props}>
      <HugeiconsIcon icon={ICONS_MAP[variant ?? "info"]} />
      {title && <AlertTitle>{title}</AlertTitle>}
      <AlertDescription>{children}</AlertDescription>
      {!!action && <AlertAction>{action}</AlertAction>}
    </BaseAlert>
  )
}
